import React from 'react';
import { useSelector } from 'react-redux';
import {
  Wrapper,
  Title,
  Information,
  Button,
  Image
} from './styled';

const ERROR_500_MESSAGE = 'Ha ocurrido un problema con nuestros servidores, por favor vuelve a cargar la página';
const ERROR_404_MESSAGE = '¡No se encontró esta página!'

const SERVER_ERROR = 500;
const NOT_FOUND_ERROR = 404;

interface Props {
  isValidPath: boolean;
}

export const Error: React.FC<Props> = ({ isValidPath }) => {

  const statusCode: number = isValidPath ? useSelector(state => state.template.statusCode): NOT_FOUND_ERROR;

  const handleClick = () => {
    window.location.reload();
  };

  return(
    <React.Fragment>
      <Wrapper>
        <Title>error {statusCode}</Title>
        <Information>
          {statusCode === SERVER_ERROR && ERROR_500_MESSAGE}
          {statusCode === NOT_FOUND_ERROR && ERROR_404_MESSAGE}
        </Information>
        <Button onClick={handleClick}>Cargar página</Button>
      </Wrapper>
      <Image />
    </React.Fragment>
  );
};
